import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./SearchMapModal.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import MapSearch from "../../comm/global/components/MapSearch";
const SearchMapModal = ({ setModalType, arg, addModalType, set_menuVisiable }) => {
    const [inProp, setInProp] = useState(false);
    //for map
    const [pageState, set_pageState] = useState("main");//main是有顯示感興趣、keyword是顯示搜尋、pots是顯示所有的點 這時候隱藏感興趣 ,selectPosition 是選取座標以建立新pot
    const [potIndex, set_potIndex] = useState(-1);
    useEffect(() => {
        setInProp(true);
    }, [])
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "SearchMapModal"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <MapSearch addModalType={addModalType} set_menuVisiable={set_menuVisiable}
                                    pageState={pageState} set_pageState={set_pageState} potIndex={potIndex} set_potIndex={set_potIndex}
                                    type="selPot"  />
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(SearchMapModal);